import { NgModule } from '@angular/core';
import { GroupPermissionsDialogComponent } from './group-permissions-dialog.component';
import { SharedModule } from '../../../shared/shared.module';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { RequestFormService } from '../../../../services/forms/request-form.service';
import { MembersService } from '../../../../services/members/members.service';
import { PermissionsService } from '../../../../services/permissions/permissions.service';

@NgModule({
  declarations: [
    GroupPermissionsDialogComponent
  ],
    imports: [
        SharedModule,
        MatCheckboxModule,
        MatSlideToggleModule,
    ],
    providers: [
        RequestFormService,
        MembersService,
        PermissionsService,
    ],
})
export class GroupPermissionsDialogModule { }
